import {deleteData, getData, postData, putData} from 'helpers/apiHelper'
import { ADD_EMAIL_MODULE_PREFERENCE, DELETE_EMAIL_MODULE_PREFERENCE, EDIT_EMAIL_MODULE_PREFERENCE, EMAIL_MODULE_SORTING, FETCH_BASIC_SETTINGS, GET_EMAIL_MODULES_LIST, MAIN_PATH  } from './apiPath'
import * as actions from 'store/actions/emailPreferences';

// get modules list
export function getModulesList(callback) {
  let url = `${MAIN_PATH}${GET_EMAIL_MODULES_LIST}`;
  return (dispatch) => getData(url)
    .then((data) => {
      dispatch(actions.getModulesList(data, callback));
      return data;
  });
}

export function addNewModule(payload, callback) {
  let url = `${MAIN_PATH}${ADD_EMAIL_MODULE_PREFERENCE}`;
  return (dispatch) => postData(url, payload)
    .then((data) => {
      dispatch(actions.addNewModule(data, callback));
      return data;
  });
}

export function editModule(payload, callback) {
  const { id, values } = payload;
  let url = `${MAIN_PATH}${EDIT_EMAIL_MODULE_PREFERENCE}/${id}`;
  return (dispatch) => putData(url, values)
    .then((data) => {
      dispatch(actions.editModule(data, callback));
      return data;
  });
}

export function deleteModule(callback) {
  let url = `${MAIN_PATH}${DELETE_EMAIL_MODULE_PREFERENCE}`;
  return (dispatch) => deleteData(url)
    .then((data) => {
      dispatch(actions.deleteModule(data, callback));
      return data;
  });
}

export function addPreference(callback) {
  let url = `${MAIN_PATH}${ADD_EMAIL_MODULE_PREFERENCE}`;
  return (dispatch) => getData(url)
    .then((data) => {
      dispatch(actions.addPreference(data, callback));
      return data;
  });
}

export function editPreference(callback) {
  let url = `${MAIN_PATH}${EDIT_EMAIL_MODULE_PREFERENCE}`;
  return (dispatch) => getData(url)
    .then((data) => {
      dispatch(actions.editPreference(data, callback));
      return data;
  });
}

export function deletePreference(callback) {
  let url = `${MAIN_PATH}${DELETE_EMAIL_MODULE_PREFERENCE}`;
  return (dispatch) => getData(url)
    .then((data) => {
      dispatch(actions.deletePreference(data, callback));
      return data;
  });
}

export function applySorting(payload, callback) {
  let url = `${MAIN_PATH}${EMAIL_MODULE_SORTING}`;
  return (dispatch) => postData(url, payload)
    .then((data) => {
      dispatch(actions.applySorting(data, callback));
      return data;
  });
}
